// eslint-disable-next-line no-unused-vars
import { h } from 'preact';
import PropTypes from 'prop-types';
import { useState, useContext, useEffect } from 'preact/hooks';
import { SearchContext } from '../contexts/Search';

const { __ } = wp.i18n;

/**
 * The main component.
 *
 * @param {Object} props Props
 * @return {Object} JSX
 */
const Search = ( props ) => {
	const { group, label } = props;
	const { state } = useContext( SearchContext );
	const { loading } = state;
	const [value, setValue] = useState( '' );
	const uniqueId = `field-${group}`.toLowerCase().replace( ' ', '_' );

	/**
	 * Handle the input change.
	 * @param {Object} event The event object.
	 */
	const handleOnInput = ( event ) => {
		const { target } = event;
		const { value } = target;

		setValue( value );
	};

	useEffect( () => {
		// Reset when loading
		if ( loading ) {
			setValue( '' );
		}
	}, [loading] );

	// Render
	return (
		<div className="facet facet--search">
			<div>
				<label htmlFor={uniqueId}>{label}</label>
				<div className="border border-gray-600 d-flex">
					<input
						className="form-control border-0 flex-grow-1 h-100 bg-transparent"
						id={uniqueId}
						type="text"
						value={value}
						onInput={handleOnInput}
					/>
					<input type="hidden" value={value} name={group} />
					<button
						className="btn btn-link-secondary m-0"
						data-bi-bhvr="61"
						data-bi-type="button"
						data-bi-cN={__( 'Submit', 'ms-research' )}
						data-bi-tN="faceted-search/sidebar"
					>
						<span className="sr-only">{__( 'Search', 'ms-research' )}</span>
						<span className="glyph-append glyph-append-search d-flex" aria-hidden="true"></span>
					</button>
				</div>
			</div>
		</div>
	);
};

Search.propTypes = {
	group: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
};

export default Search;
